import React from "react";
import {Typography} from "@mui/material";

interface BreadcrumbProps {
  children: React.ReactNode;
}

/**
 * A single breadcrumb item for use inside `PageHeader`.
 *
 * @see {@link PageHeader} for the full page header component that renders these breadcrumb items in a MUI `Breadcrumbs` container.
 */
const Breadcrumb = ({ children }: BreadcrumbProps) => (
  <Typography
    sx={{
      color: "#5C6771",
      textTransform: "uppercase",
      fontSize: "12px",
      fontWeight: 500,
      lineHeight: "14px",
    }}
  >
    {children}
  </Typography>
);

export default Breadcrumb;
